import * as angular from "angular";
import {IController, IQService} from "angular";
import * as _ from "lodash";

export class subTaskTemplateMultiSelectCtrl implements IController {

  selectedIds: string[];
  excludedIds: string[];
  options: any;
  optionIds: any;
  disableIds: any;
  isRequired: boolean;
  types: any;
  ngPlaceholder: string;
  noUnderline: boolean;
  isDisabled: boolean;
  onChange: Function;

  private subTasksTemplatesRef: any;

  public selectedText: any;
  public selectedSubtaskTemplates: any;

  /* @ngInject */
  constructor(private $mdPanel, private $element, private $log, private $subTasksTemplates) {
    this.subTasksTemplatesRef = this.$subTasksTemplates();
  }

  $onInit() {
    this._setSelectedSubTaskTemplates();
  };

  $onChanges(changes) {
    if (changes.selectedIds && !changes.selectedIds.isFirstChange()) {
      this._setSelectedSubTaskTemplates();
    }
  };

  /////////////////////////////////////////////////////


  onShowPanel($event) {

    if (!!this.isDisabled) {
      return;
    }

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-select-input')
      .withAnimation(this.$mdPanel.animation.FADE);

    const selectedIdsRef = this.selectedIds;
    const excludeIdsRef = this.excludedIds;
    const optionsRef = this.options;
    const optionIdsRef = this.optionIds;
    const ngPlaceholderRef = this.ngPlaceholder;
    const typesRef = this.types;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-multi-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-ids="ctrl.selectedIdsRef" ' +
        'options="ctrl.optionsRef" ' +
        'option-ids="ctrl.optionIdsRef" ' +
        'exclude-ids="ctrl.excludeIdsRef" ' +
        'ng-placeholder="ctrl.ngPlaceholderRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'query-map="ctrl.queryMapRef" ' +
        'service-areas-types="ctrl.serviceTypesRef" ' +
        'exclude-ids="ctrl.excludeIdsRef">' +
        '</bringoz-multi-select-filter-panel>',
      controller: function () {
        this.typeRef = 'subtaskTemplates';
        this.selectedIdsRef = selectedIdsRef;
        this.excludeIdsRef = excludeIdsRef;
        this.optionsRef = optionsRef;
        this.optionIdsRef = optionIdsRef;
        this.ngPlaceholderRef = ngPlaceholderRef;
        this.queryMapRef = {
          types: typesRef
        }
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedIds) => {
        if (selectedIds === 'clickOutsideToClose' || selectedIds === 'escapeToClose') {
          selectedIds = selectedIdsRef;
        }

        if (!selectedIds?.length) {
          this.onChange({templates: [], templateIds: []});
          panel.destroy();
        } else {
          if (!!this.options) {
            const subtaskTemplates = _.filter(this.options, (o) => {
              return _.includes(selectedIds, o.id);
            });
            this.onChange({templates: subtaskTemplates, templateIds: selectedIds});
            panel.destroy();
          } else {
            this.subTasksTemplatesRef.$asyncValues(selectedIds)
              .then((templates) => {
                this.onChange({templates: templates, templateIds: selectedIds});
                panel.destroy();
              });
          }
        }
      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({templateIds: [], templates: []});
  }

  private _setSelectedSubTaskTemplates() {
    if (!!this.selectedIds) {
      if (!!this.options) {
        this.selectedSubtaskTemplates = _.filter(this.options, (o) => {
          return _.includes(this.selectedIds, o.id);
        });
        this._setSelectedText();
      } else {
        this.subTasksTemplatesRef.$asyncValues(this.selectedIds)
          .then((templates) => {
            this.selectedSubtaskTemplates = _.orderBy(templates, ['title'], ['asc']);
            this._setSelectedText();
          });
      }
    } else {
      this.selectedSubtaskTemplates = [];
      this._setSelectedText();
    }
  }


  private _setSelectedText() {
    let string = '';
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext("2d");

    _.forEach(this.selectedSubtaskTemplates, (b, i) => {
      string += b.title;
      if ((i + 1) < this.selectedSubtaskTemplates.length) {
        string += ', '
      }
    });

    var stringWidth = ctx.measureText(string).width;
    if (this.$element[0]?.clientWidth && (stringWidth + 80) >= (this.$element[0].clientWidth - 30)) {
      string = this.selectedSubtaskTemplates[0].title + ` +${this.selectedSubtaskTemplates.length - 1}`
    }
    this.selectedText = string;
  }

}

angular
  .module('bringoz.admin.sub-tasks')
  .component('subTaskTemplateMultiSelect', {
    bindings: {
      selectedIds: '<',
      options: '<?',
      optionIds: '<?',
      types: '<?',
      excludedIds: '<?',
      isRequired: '<?',
      isDisabled: '<?',
      ngPlaceholder: '@?',
      noUnderline: '@?',
      onChange: '&'
    },
    template: require('./sub-task-template-multi-select.html').default,
    controller: subTaskTemplateMultiSelectCtrl
  });
